import { TrpcRouter } from 'je-bff/src/handlers/bff';
import { createTRPCReact } from '@trpc/react-query';

export const trpcBff = createTRPCReact<TrpcRouter>();
